/* eslint-disable */
import axios from 'axios';
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
const idtoken = store.getters.getIdToken;
export default {
    name: 'ResearchFhirSubject',
    components: {
        VPagination,
    },
    data() {
        return {
            spinner: false,
            defaultdate: "",
            milestoneList: [],
            baseapi: process.env.VUE_APP_Service_URL,
            baseUrl: `${process.env.VUE_APP_Service_URL}`,
            searchdata: {
                SubjectId: "",
                Milestone: "",
                SubjectState: "",
                StartDate: "",
                EndDate: "",
                Pageindex: 1,
                Pagesize: 10,
                SortProperty: "",
                SortOrder: 1,
            },
            sites: "",
            siteCodes: [],
            selectedSiteCode: "",
            isRefreshing: false,
            subjectList: [],
            scheduledarray: [],
            patientId: "",
            SortProperty: "",
            milestones: "",
            idToken: "",
            SortOrder: 0,
            subjectStates: "",
            selectedType: "",
            selectedId: "",
            dataList: [],
            statusCheck: "",
            creatingScheduleId: null,
            searchItem: "",
            siteId: "",
            currentPage: 1,
            showLoading: true,
            enableNext: true,
            enablePrevious: true,
            showFilter: false,
            dropdownOpen: false,
            selectedcolumnobj: { "Subject ID": true, "Enrollment Date": true, "Milestone": true, "Milestone Date": true, "Subject State": true, "State Start Date": true, "Last Synced": true, "Last Updated": true },
            totalLists: 0,
            totalPages: 0,
            lists: [],
            selectedColumns: [],

            filteredListing: [],
            subjectStateList: [],
            roleprivileges: "",
            spinsync: {},
        }
    },
    async mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.showLoading = true
            this.idToken = store.getters.getIdToken;
            this.roleprivileges = store.getters.getRolesprivilegeData;
            this.researchSubject();
            this.fetchSubjects();
            this.fetchSiteCodes();
            this.initializeColumns();
        });
        this.idToken = store.getters.getIdToken;
        this.roleprivileges = store.getters.getRolesprivilegeData;
        await this.researchSubject();
        await this.fetchSubjects();
        await this.fetchSiteCodes();
        this.initializeColumns();
    },


    methods: {
        initializeColumns() {
            if (this.subjectList.length > 0) {
                this.spinner = true;
                const allowedKeys = [
                    "SubjectCode",
                    "EnrollmentDate",
                    "Milestone",
                    "MilestoneDate",
                    "State",
                    "StateStartDate",
                    "LastSyncedAt",
                    "LastUpdatedAt"
                ];
                this.getColumns = Object.keys(this.subjectList[0])
                    .filter(column => allowedKeys.includes(column));
                const fieldLabels = {
                    SubjectCode: "Subject ID",
                    EnrollmentDate: "Enrollment Date",
                    Milestone: "Milestone",
                    MilestoneDate: "Milestone Date",
                    State: "Subject State",
                    StateStartDate: "State Start Date",
                    LastSyncedAt: "Last Synced",
                    LastUpdatedAt: "Last Updated"
                };

                const readableData = allowedKeys.map(key => fieldLabels[key] || key);

                this.getColumns = readableData
                this.selectedColumns = [...this.getColumns];
                this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
                    obj[key] = true;
                    return obj;
                }, {});
            }
            this.spinner = false;
        },


        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate)
            }
        },
        SortSelected(property) {
            console.log('SortPropChanged', property);

            if (this.SortProperty === property) {
                this.SortOrder = this.SortOrder === 0 ? 1 : 0;
            } else {

                this.SortProperty = property;
                this.SortOrder = 0;
            }
            this.activeSortColumn = property;
            console.log(`Sorting by ${property}, order: ${this.SortOrder}`);
            this.searchdata.SortOrder = this.SortOrder;
            this.searchdata.SortProperty = property;
            this.currentPage = 1;
            this.searchdata.Pageindex = 1;
            this.fetchSubjects();
        },
        async fetchSubjects() {
            const idtoken = store.getters.getIdToken;
            try {
                const response = await axios.get(
                    // `${this.baseUrl}/fhir-service/researchsubject/getresearchsubject?StudyId=${store.getters.getStudyIs}&SortOrder=${this.searchdata.SortOrder}&PageIndex=${this.searchdata.Pageindex}&PageSize=${this.searchdata.Pagesize}&SortProperty=${this.searchdata.SortProperty}`,
                    `${this.baseUrl}/fhir-service/researchsubject/getresearchsubject?StudyId=${store.getters.getStudyIs}&PageIndex=${this.searchdata.Pageindex}&PageSize=${this.searchdata.Pagesize}&SortProperty=${this.searchdata.SortProperty}&SortOrder=${this.searchdata.SortOrder}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.data) {
                    this.subjectList = response.data.items;
                    console.log("this.subjectList in fetch subject", this.subjectList);
                    this.totalLists = Math.ceil(response.data.totalCount / 10);
                    const values = this.subjectList.filter(o => Object.prototype.hasOwnProperty.call(o, "SubjectCode")).map(o => o.SubjectCode);
                    this.listsubjectcode(values);

                }
                this.showLoading = false;
            } catch (err) {
                console.log(err);
                this.showLoading = false;
            }
        },
        async listsubjectcode(values) {
            console.log("values", values);
            const idtoken = store.getters.getIdToken;
            let payload = "";
            values.forEach(element => {
                payload = payload + "&SubjectIds=" + element;
            });
            try {
                const response = await axios.get(
                    `${this.baseUrl}/management/patientschedule/listsubjectcode?StudyId=${store.getters.getStudyIs}${payload}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.data) {
                    console.log("response.data", response.data);
                    this.scheduledarray = response.data.data;
                }
            } catch (err) {
                console.log(err);
            }
        },
        isscheduled(subjectid) {
            const isscheduleddata = this.scheduledarray.find(
                prev => prev.patientNo === subjectid
            );
            if (isscheduleddata && isscheduleddata.status) {
                    return isscheduleddata.status;
                }
                else {
                    return;           // or return undefined; (both are same)
                }
        },
        gotosubjecttree(subjectid, SiteId) {
            console.log("go to subject tree");
            this.$router.push(`/subject_tree/${subjectid}`);
        },


        async SearchButtonClicked() {
            this.currentPage = 1;
            this.searchdata.Pageindex = 1;
            this.searchDatafun();
        },
        formatdatetime(data) {
             if (data) {
                return moment(data).format(this.defaultdate)
            }
        },
        async searchDatafun() {
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            const url = this.buildUrl(
                `${this.baseUrl}/fhir-service/researchsubject/getresearchsubject`,
                {
                    StudyId: stdid,
                    SubjectCode: this.searchdata.SubjectCode,
                    Milestone: this.searchdata.Milestone,
                    SubjectState: this.searchdata.SubjectState,
                    FromEnrollmentDate: this.searchdata.StartDate,
                    ToEnrollmentDate: this.searchdata.EndDate,
                    pageindex: this.searchdata.Pageindex,
                    pagesize: this.searchdata.Pagesize,
                    SortProperty: this.searchdata.SortProperty,
                    SortOrder: this.searchdata.SortOrder,
                }
            );
            try {
                const response = await axios.get(
                    `${url}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.subjectList = Array.isArray(response.data.items) ? response.data.items : [];
                console.log("this.subjectList in searchData", this.subjectList);
                this.showLoading = false;

            } catch (err) {
                console.log(err);
                this.showLoading = false;
            }
        },
        buildUrl(baseUrl, params) {
            var qs = new URLSearchParams();
            Object.keys(params).forEach(function (k) {
                var v = params[k];
                if (v !== undefined && v !== null && v !== "") {
                    qs.append(k, v);
                }
            });
            return qs.toString() ? baseUrl + "?" + qs.toString() : baseUrl;
        },
        async fetchSiteCodes() {
            const idtoken = store.getters.getIdToken;
            try {
                const response = await axios.get(
                    `${this.baseUrl}/management/site/getall?studyId=${store.getters.getStudyIs}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.data) {
                    this.siteCodes = response.data;
                    this.selectedSiteCode = this.siteCodes[0]?this.siteCodes[0].siteID:"";             
                   }
            } catch (err) {
                console.log(err);
            }
        },
        async refreshData() {
            this.isRefreshing = true;
            const idtoken = store.getters.getIdToken;
            try {
                const response = await axios.post(
                    `${this.baseUrl}/fhir-service/fhir/syncfhirresearchsubjects?study_id=${store.getters.getStudyIs}&site_id=${this.selectedSiteCode}`,
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                await this.researchSubject();
                // await this.genericformsmapping();

            } catch (error) {
                console.error('Error refreshing data:', error);
                this.$toast.error('Failed to refresh data');
            } finally {
                this.isRefreshing = false;
            }
        },
        async genericformsmapping() {
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            try {
                const response = await axios.post(
                    `${this.baseUrl}/fhir-service/fhir/genericformsmapping?study_id=${currentstudy}`,
                     {},
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("success");
            } catch (err) {
                console.error("Error fetching subjects:", err);
            }
        },
        async syncSubject(SubjectCode) {
            if(!this.isscheduled(SubjectCode)){
                alert("No schedules found for the Subject");
                return;
            }
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            this.spinsync[SubjectCode] = true;
            try {
                const response = await axios.post(
                    `${this.baseUrl}/fhir-service/fhir/genericformsmapping?study_id=${currentstudy}&subject_id=${SubjectCode}`,
                     {},
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("success");
                this.spinsync[SubjectCode] = false;
                alert("Data synchronized Successfully")
            } catch (err) {
                console.error("Error fetching subjects:", err);
                 this.spinsync[SubjectCode] = false;
            }
        },

        async researchSubject() {
            this.showLoading = true;
            let subjectList = [];
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            try {
                const response = await axios.get(
                    `${this.baseUrl}/fhir-service/researchsubject/getresearchsubject?StudyId=${currentstudy}&pageindex=${this.searchdata.Pageindex}&pagesize=${this.searchdata.Pagesize}&SortProperty=${this.searchdata.SortProperty}&SortOrder=${this.searchdata.SortOrder}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                subjectList = Array.isArray(response.data.items) ? response.data.items : [];

                this.subjectList = subjectList;

                this.dataList = [...new Set(subjectList.map(subject => subject.SubjectCode))];
                this.milestoneList = [...new Set(subjectList.map(subject => subject.Milestone))];
                this.subjectStateList = [...new Set(subjectList.map(subject => subject.State))];

                if (response.data && typeof response.data.totalCount === "number") {
                    this.totalLists = Math.ceil(response.data.totalCount / this.searchdata.Pagesize);
                    this.totalPages = Math.ceil(response.data.totalCount / this.searchdata.Pagesize);
                }

                this.showLoading = false;
            } catch (err) {
                console.error("Error fetching subjects:", err);
                this.$toast?.error("Failed to load subjects");
                this.showLoading = false;
                this.subjectList = [];
            }
        },
        async postSchedule(patientId) {
            alert("Are you sure you want to create schedule for this subject?");
             this.creatingScheduleId = patientId;
            const idtoken = store.getters.getIdToken;
            const valnow = store.getters.getStudyIs;
            try {
                await axios.post(
                    `${this.baseUrl}/management/patientschedule/schedule`,
                    {
                        studyId: valnow,
                        patientId: patientId,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                        },
                    }
                );
                alert(this.$t("navigations.schedule created successfully"));
                await this.researchSubject();
                const values = this.subjectList.filter(o => Object.prototype.hasOwnProperty.call(o, "SubjectCode")).map(o => o.SubjectCode);
                await this.listsubjectcode(values);
            } catch (err) {
                console.log(err);
            }
            finally {
    this.creatingScheduleId = null;
  }
        },

        async loadPage(page) {
            this.currentPage = page;
            this.searchdata.Pageindex = page;
            console.log("Current Page:", page);
            await this.fetchSubjects();
        }
    },

}